// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir=ltr] .assignee-selector[data-v-efa65adc]  .vs__dropdown-toggle {\n  padding-left: 0;\n}[dir=rtl] .assignee-selector[data-v-efa65adc]  .vs__dropdown-toggle {\n  padding-right: 0;\n}", ""]);
// Exports
module.exports = exports;
